import React, { useEffect, useState } from 'react';
import './Servicios.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import moneda from '../moneda';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import ServiciosLoading from '../ServiciosLoading/ServiciosLoading';

export default function Servicios() {
    const [servicios, setServicios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubcategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mostrarInterior, setMostrarInterior] = useState(false); // 👈 nuevo estado

    SwiperCore.use([Navigation, Pagination, Autoplay]);

    useEffect(() => {
        cargarServicios();
        cargarCategoria();
        cargarSubcategorias();
    }, []);

    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarSubcategorias = () => {
        fetch(`${baseURL}/subCategoriaGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setSubcategorias(data.subcategorias || []);
            })
            .catch(error => console.error('Error al cargar subcategorías:', error));
    };

    // 👇 Rango que define qué categorías van agrupadas bajo "Interior provincial"
    const RANGO_INTERIOR_MIN = 100;
    const RANGO_INTERIOR_MAX = 150;

    const esInterior = (idCategoria) =>
        idCategoria >= RANGO_INTERIOR_MIN && idCategoria <= RANGO_INTERIOR_MAX;

    const categoriasFijas = categorias?.filter(c => !esInterior(c.idCategoria)) || [];
    const categoriasInterior = categorias?.filter(c => esInterior(c.idCategoria)) || [];

    // Filtrar servicios por categoría seleccionada
    const serviciosFiltradosPorCategoria = categoriaSeleccionada
        ? servicios?.filter(servicio => servicio.idCategoria === categoriaSeleccionada)
        : servicios;

    return (
        <div id='Servicios'>

            {loading ? (
                <ServiciosLoading />
            ) : (
                <div>

                    {/* FILTRO POR CATEGORÍA */}
                    <div className="filtrosCategorias">
                        {
                            servicios.length > 0 &&
                            <button
                                type="button"
                                className={`categoriaBoton ${!categoriaSeleccionada ? 'activeCategoria' : ''}`}
                                onClick={() => setCategoriaSeleccionada(null)}
                            >
                                Todo
                            </button>
                        }

                        {/* Categorías fijas (las que NO están en el rango 30-40) */}
                        {categoriasFijas?.map(categoria => (
                            <button
                                type="button"
                                key={categoria.idCategoria}
                                className={`categoriaBoton ${categoriaSeleccionada === categoria.idCategoria ? 'activeCategoria' : ''}`}
                                onClick={() => setCategoriaSeleccionada(categoria.idCategoria)}
                            >
                                {categoria.categoria}
                            </button>
                        ))}

                        {/* Botón para desplegar el grupo "Interior provincial" */}
                        {categoriasInterior.length > 0 && (
                            <button
                                type="button"
                                className={`categoriaBoton categoriaGrupoBoton ${mostrarInterior ? 'activeGrupo' : ''}`}
                                onClick={() => setMostrarInterior(prev => !prev)}
                            >
                                Interior provincial
                                <FontAwesomeIcon icon={mostrarInterior ? faChevronUp : faChevronDown} className="iconGrupo" />
                            </button>
                        )}
                    </div>

                    {/* Categorías del grupo "Interior provincial", solo si está desplegado */}
                    {mostrarInterior && (
                        <div className="filtrosCategorias filtrosInterior">
                            {categoriasInterior?.map(categoria => (
                                <button
                                    type="button"
                                    key={categoria.idCategoria}
                                    className={`categoriaBoton ${categoriaSeleccionada === categoria.idCategoria ? 'activeCategoria' : ''}`}
                                    onClick={() => setCategoriaSeleccionada(categoria.idCategoria)}
                                >
                                    {categoria.categoria}
                                </button>
                            ))}
                        </div>
                    )}

                    {categorias
                        ?.filter(categoria =>
                            serviciosFiltradosPorCategoria?.some(servicio => servicio.idCategoria === categoria.idCategoria)
                        )
                        ?.map(categoria => (
                            <div key={categoria.idCategoria} className="categoriaSection">

                                {!categoriaSeleccionada && (
                                    <h2
                                        className="categoriaHeaderBoton"
                                        onClick={() => setCategoriaSeleccionada(categoria.idCategoria)}
                                    >
                                        <span>{categoria.categoria}</span>
                                        <FontAwesomeIcon icon={faAngleDoubleRight} className="iconCardh2" />
                                    </h2>
                                )}

                                {!categoriaSeleccionada ? (
                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id="cardsServicio"
                                        autoplay={{ delay: 3000 }}
                                    >
                                        {servicios
                                            ?.filter(servicio => servicio.idCategoria === categoria.idCategoria)
                                            ?.map(servicio => (
                                                <SwiperSlide key={servicio.idServicio} id="cardServicio">
                                                    <Anchor
                                                        to={`servicio/${servicio.idServicio}/${servicio?.titulo?.replace(/\s+/g, '-')}`}
                                                    >
                                                        {subcategorias
                                                            ?.filter(subcategoria =>
                                                                subcategoria.idCategoria === categoria.idCategoria &&
                                                                subcategoria.idSubCategoria === servicio.idSubCategoria
                                                            )
                                                            ?.map(item => (
                                                                <h6 className="subcategoria" key={item.idSubCategoria}>
                                                                    {item.subcategoria}
                                                                </h6>
                                                            ))}

                                                        <div className='imgCard'>
                                                            <img src={servicio.imagen1} alt={servicio.titulo} />
                                                        </div>

                                                        <div className="cardServicioText">
                                                            <h3>{servicio.titulo}</h3>
                                                            <span> <i className="fa fa-map-marker"></i> {servicio.direccion}</span>
                                                        </div>
                                                    </Anchor>
                                                </SwiperSlide>
                                            ))}
                                    </Swiper>
                                ) : (
                                    <div className="serviciosLista">
                                        {serviciosFiltradosPorCategoria
                                            ?.filter(servicio => servicio.idCategoria === categoria.idCategoria)
                                            ?.map(servicio => (
                                                <div key={servicio.idServicio} id="cardServicio">
                                                    <Anchor to={`servicio/${servicio.idServicio}/${servicio?.titulo?.replace(/\s+/g, '-')}`}>

                                                        {subcategorias
                                                            ?.filter(subcategoria =>
                                                                subcategoria.idCategoria === categoria.idCategoria &&
                                                                subcategoria.idSubCategoria === servicio.idSubCategoria
                                                            )
                                                            ?.map(item => (
                                                                <h6 className="subcategoria" key={item.idSubCategoria}>
                                                                    {item.subcategoria}
                                                                </h6>
                                                            ))}

                                                        <div className='imgCard'>
                                                            <img src={servicio.imagen1} alt={servicio.titulo} />
                                                        </div>

                                                        <div className="cardServicioText">
                                                            <h3>{servicio.titulo}</h3>
                                                            <span> <i className="fa fa-map-marker"></i> {servicio.direccion}</span>
                                                        </div>

                                                    </Anchor>
                                                </div>
                                            ))}
                                    </div>
                                )}
                            </div>
                        ))}

                </div>
            )}

        </div>
    );
}